interface DesktopOrderTypeTabsProps {
  selectedOrderType: 'DEADLINE_DISCOUNT' | 'RESERVATION_DISCOUNT' | 'REGULAR_ORDER';
  onOrderTypeChange: (type: 'DEADLINE_DISCOUNT' | 'RESERVATION_DISCOUNT' | 'REGULAR_ORDER') => void;
}

export function DesktopOrderTypeTabs({ selectedOrderType, onOrderTypeChange }: DesktopOrderTypeTabsProps) {
  const getOrderTypeInfo = (type: 'DEADLINE_DISCOUNT' | 'RESERVATION_DISCOUNT' | 'REGULAR_ORDER') => {
    switch (type) {
      case 'DEADLINE_DISCOUNT':
        return {
          label: '마감할인',
          description: '오늘 만든 식품을 마감 전 할인하여 판매하는 상품입니다'
        };
      case 'RESERVATION_DISCOUNT':
        return {
          label: '예약할인',
          description: '전날 예약하고 내일 할인된 시간에 수령하는 상품입니다'
        };
      case 'REGULAR_ORDER':
        return {
          label: '일반주문',
          description: '일반 주문하여 당일 수령하는 일반가격 상품입니다'
        };
    }
  };

  const currentOrderTypeInfo = getOrderTypeInfo(selectedOrderType);

  return (
    <div className="mb-8">
      {/* Tab Buttons */}
      <div className="flex border-2 border-[#DEDEDE] rounded-2xl overflow-hidden mb-6 max-w-2xl mx-auto">
        {(['DEADLINE_DISCOUNT', 'RESERVATION_DISCOUNT', 'REGULAR_ORDER'] as const).map((type) => (
          <button
            key={type}
            onClick={() => onOrderTypeChange(type)}
            className={`py-4 px-8 text-xl font-bold transition-colors flex-1 ${
              selectedOrderType === type
                ? 'bg-[#86DB89] text-white'
                : 'bg-white text-[#222222] hover:bg-gray-50'
            }`}
          >
            {getOrderTypeInfo(type).label}
          </button>
        ))}
      </div>

      {/* Selected Order Type Description */}
      <div className="text-center max-w-3xl mx-auto">
        <div className="inline-block border-b-2 border-[#222222] pb-2">
          <p className="text-lg text-[#222222] font-medium">
            {currentOrderTypeInfo.description}
          </p>
        </div>
      </div>
    </div>
  );
}